import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchPendingUsers,
  approveUser,
  rejectUser,
} from "../../redux/slices/pendingUserSlice";

const PendingUsers = ({ user, onLogout }) => {
  const dispatch = useDispatch();

  // Redux state
  const { users, loading } = useSelector(
    (state) => state.pendingUsers || { users: [] }
  );

  // Fetch users once
  useEffect(() => {
    dispatch(fetchPendingUsers());
  }, [dispatch]);

  const handleApprove = (usr) => {
    dispatch(approveUser({ requestId: usr.id }));
  };

  // Handle Reject
  const handleReject = (requestId) => {
    dispatch(rejectUser(requestId));
  };

  if (loading) return <p>Loading...</p>;

  return (
    <>
      <div className="container-fluid">
        <h4>Pending Users Approval</h4>
        <table className="table table-bordered mt-3">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Requested Role</th>
              <th>Company</th>
              <th>Current Step</th>
              <th>Approval Progress</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users && users.length > 0 ? (
              users.map((usr) => {
                const canAct = usr.can_current_user_act;
                const hasApproved = usr.has_current_user_approved;
                const totalSteps = usr.total_steps || 0;
                return (
                  <tr key={usr.id}>
                    <td>{usr.user.name}</td>
                    <td>{usr.user.email}</td>
                    <td>{usr.role?.name || usr.user.role}</td>
                    <td>{usr.company?.name || "—"}</td>
                    <td>
                      <div>
                        <strong>
                          Step {usr.current_step || 1}/{totalSteps}
                        </strong>
                        {usr.current_step_role && (
                          <div className="text-muted small">
                            Completed:{usr.current_step_role}
                            <br />
                            Waiting: {usr.next_step_role || "No more steps"}
                          </div>
                        )}
                      </div>
                      {/* Step status badges */}
                      {usr.step_status && usr.step_status.length > 0 && (
                        <div className="mt-1 d-flex flex-wrap gap-1">
                          {usr.step_status.map((step, idx) => (
                            <span
                              key={idx}
                              className={`badge ${
                                step.approved
                                  ? "bg-success"
                                  : idx + 1 === (usr.current_step || 1)
                                  ? "bg-warning text-dark"
                                  : "bg-secondary"
                              }`}
                              title={`${step.role_name} (${step.company_name})`}
                              style={{ fontSize: "0.7em" }}
                            >
                              {step.role_name}
                              {step.is_mother_company && " 🏢"}
                            </span>
                          ))}
                        </div>
                      )}
                    </td>
                    <td style={{ width: "200px" }}>
                      <div className="progress" style={{ height: "20px" }}>
                        <div
                          className={`progress-bar ${
                            usr.approval_progress === 100
                              ? "bg-success"
                              : usr.approval_progress >= 50
                              ? "bg-info"
                              : "bg-warning"
                          }`}
                          role="progressbar"
                          style={{ width: `${usr.approval_progress}%` }}
                          aria-valuenow={usr.approval_progress}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        >
                          {usr.approval_progress}%
                        </div>
                      </div>
                    </td>
                    <td>
                      {usr.approval_status === "pending"   && (
                        <>
                          <button
                            className="btn btn-success btn-sm me-2"
                            onClick={() => handleApprove(usr)}
                          >
                            ✅ Approve
                          </button>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleReject(usr.id)}
                          >
                            ❌ Reject
                          </button>
                        </>
                      )}

                      {usr.approval_status === "pending" && !canAct && (
                        <span className="text-muted small">
                          {hasApproved ? (
                            <>
                              ✅ You approved.{" "}
                              {usr.next_step_role
                                ? `Waiting: ${usr.next_step_role}`
                                : "Waiting for remaining approvals"}
                            </>
                          ) : (
                            <>Not your turn to approve</>
                          )}
                        </span>
                      )}

                      {usr.approval_status === "approved" && (
                        <span className="badge bg-success">All approvals completed</span>
                      )}

                      {usr.approval_status === "rejected" && (
                        <span className="badge bg-danger">Request rejected</span>
                      )}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td
                  colSpan={7}
                  className="text-center py-3"
                  style={{ fontWeight: "bold", fontSize: "2em" }}
                >
                  No Pending Users
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PendingUsers;
